<template>
  <div class="FreezeHeader">
    <div class="FreezeHeader-container PageContainer">
      <div class="FreezeHeader-content">
        <h5 class="FreezeHeader-title">{{ t('custom.landing.freeze.header.title') }}</h5>
        <p class="FreezeHeader-description">{{ t('custom.landing.freeze.header.description') }}</p>
      </div>

      <Countdown
        class="FreezeHeader-countdown"
        format="DD:HH:MM:SS"
        :start="startDate"
        :end="endDate"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
const { startDate, endDate } = useFreezePeriod();
const { t } = useI18n();
</script>